


















import { Component, Prop, Vue } from "vue-property-decorator";
import { DataItem } from "@/data.model";
import Card from "@/components/Card/Card.vue";

@Component({
  components: { Card }
})
export default class ListBody extends Vue {
  @Prop() readonly date!: string;
  @Prop() readonly isHidden!: boolean;
  @Prop() readonly items!: DataItem[];
}
